import { render, staticRenderFns } from "./38.vue?vue&type=template&id=39d05220&scoped=true&"
import script from "./38.vue?vue&type=script&lang=js&"
export * from "./38.vue?vue&type=script&lang=js&"
import style0 from "./38.vue?vue&type=style&index=0&id=39d05220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d05220",
  null
  
)

export default component.exports